import React from 'react';
import { Link } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import { useTranslation } from 'react-i18next';

import SearchSVG from '../assets/icons/search.svg'
import BannerImg from '../assets/images/banner.png'

const IndexBanner = () => {
    const { t } = useTranslation('marketplace');

    return (
        <section className="home-banner" style={{backgroundImage: `URL(${BannerImg})`}}>
            <div className="container">
                <div className="caption-box">
                    <h2>{t('home.bannerHeading')}</h2>
                    <Link to="/search" className="btn btn-secondary">
                        <ReactSVG className="icon" src={SearchSVG} />
                        {t('home.searchAndBookNow')}
                    </Link>
                </div>
            </div>
        </section>
    );
}

export default IndexBanner;
